<template>
  <form v-on:submit.prevent="edit_Product">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">商品編集</p>
      </header>
      <section class="modal-card-body">
        <b-field label="商品名">
          <b-input
            name="name"
            data-vv-name="商品名"
            type="text"
            v-model="name"
            v-validate="'required'"
          ></b-input>
        </b-field>
        <b-field label="価格">
          <b-input
            name="price"
            data-vv-name="価格"
            type="number"
            v-model.number="price"
            v-validate="'required'"
          ></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" v-on:click="close_Edit">キャンセル</button>
        <button class="button" type="submit">保存する</button>
      </footer>
    </div>
  </form>
</template>

<script>
import product_API from "@/store/Product_API.js";
import toastre from "@/mixin/Toaster.vue";
export default {
  name: "edit",
  mixins: [toastre],
  data: function() {
    return {
      ivent_id: this.$store.getters["product/ivent_id"],
      product_id: this.$store.getters["product/edit"].product_id,
      name: this.$store.getters["product/edit"].name,
      price: this.$store.getters["product/edit"].price
    };
  },
  methods: {
    // 商品の編集
    edit_Product: function() {
      product_API
        .pacth_Product(
          this.user,
          this.ivent_id,
          this.product_id,
          this.name,
          this.price
        )
        .then(
          () => {
            this.close_Edit();
          },
          () => {
            this.display_Error(
              "商品の編集に失敗しました。再度お試しください。連続して失敗する場合はご連絡ください。"
            );
          }
        );
    },
    validate_Form: function() {
      this.$validator.validate().then(is_not_validate => {
        if (is_not_validate) {
          this.edit_Product();
          return;
        }

        this.display_Error(this.$validator.errors.first("*"));
      });
    },
    close_Edit: function() {
      this.$emit("order_Close_Edit");
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/get"];
    }
  }
};
</script>
